import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import GoogleIcon from '../components/GoogleIcon';
import { startGoogleSignIn } from '../services/googleSignIn';

// Unlisted web sign-in for testers without Android devices; intentionally not linked from the site.
function SignInPage() {
  const [error, setError] = useState('');

  const handleSignIn = async () => {
    setError('');
    try {
      await startGoogleSignIn();
    } catch (err) {
      console.error('Unable to open Google sign-in:', err);
      setError('Unable to start Google sign-in. Please try again.');
    }
  };

  return (
    <div className="landing">
      <section className="landing-hero">
        <img src="/favicon.png?v=2" alt="" className="landing-logo" />
        <h2>Sign in to StandLogic</h2>

        {error && <div className="alert alert-error" role="alert">{error}</div>}

        <div className="landing-cta">
          <button type="button" className="btn btn-google btn-lg" onClick={handleSignIn}>
            <GoogleIcon />
            Sign in with Google
          </button>
        </div>
        <p className="auth-note">
          Use the same Google account you use in the StandLogic Android app.{' '}
          <Link to="/support" state={{ tab: 'google-auth' }}>Why Google?</Link>
        </p>
      </section>
    </div>
  );
}

export default SignInPage;
